import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

const runtimeEnv =
  typeof window === "undefined"
    ? (process.env as unknown as Record<string, string | undefined>)
    : import.meta.env;

export const env = createEnv({
  clientPrefix: "VITE_",
  client: {
    VITE_PUBLIC_SERVER: z.string().trim().url(),
    VITE_SENTRY_DSN: z.string().trim().url(),
    VITE_CLERK_PUBLISHABLE_KEY: z.string().trim().min(1),
  },
  runtimeEnv,
  emptyStringAsUndefined: true,
});
